import type { Guest } from '@mathflat/domain/@entities/Guest/type'

import { SchoolGrade, StudentColl, StudentGroups } from '@/dto'
import { GuestStudent } from '@/dto/Student/GuestStudent'

/**
 * id 는 String(guest.id) 로 통일한다 — guest URL 의 :studentId 가 문자열이어서,
 * 통일하지 않으면 선택·복원이 서로 다른 key 로 갈라진다.
 */
export const guestsToStudentGroups = (guests: Guest[]): StudentGroups => {
  const students = guests.map((guest) => {
    const schoolGrade = SchoolGrade.fromGuest(guest)

    return new GuestStudent({
      id: String(guest.id),
      name: guest.name,
      schoolType: schoolGrade.schoolType,
      grade: schoolGrade.grade,
      creverseStdId: guest.creverseStdId,
    })
  })

  return StudentGroups.fromStudentColl(new StudentColl(students))
}
